import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Col } from 'antd';

import { AllotmentRangeGeneralView } from 'src/app/products/allotment-range/form/parts/allotment-range-general.view';
import { AllotmentRangeAllotmentRangeDailyView } from 'src/app/products/allotment-range/form/parts/allotmentrange-daily.view';

interface Props extends ComponentViewProps<AllotmentRangeItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	allotment: AllotmentItem;
	contextService: any;
	formatService: any;
}

@observer
export class AllotmentRangeFormView extends React.Component<Props, any> {
	render() {
		if (this.props.model == null) {
			return null;
		}

		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col xs={24} lg={24}>
						<AllotmentRangeGeneralView
							mode={this.props.mode}
							allotment={this.props.allotment}
							model={this.props.model}
							setBusy={this.props.setBusy}
							contextService={this.props.contextService}
						/>
					</Col>
				</Row>
				<Row gutter={16}>
					{
						this.props.model.dailyLimit && (this.props.model.allotmentRangeType == 1 || this.props.model.allotmentRangeType == 2) &&
						<Col xs={24} xl={24}>
							<AllotmentRangeAllotmentRangeDailyView
								mode={this.props.mode}
								onModeChanged={this.props.onModeChanged}
								model={this.props.model}
								setBusy={this.props.setBusy}
								contextService={this.props.contextService}
							/>
						</Col>
					}
				</Row>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/allotment-range/form/allotment-range-form.view.tsx